import { defineStore } from 'pinia'
import cloneDeep from 'lodash/cloneDeep'
import {
  defaultSelectedGroup,
  defaultAlertCriteria,
  defaultBacktesterCriteria,
  defaultInsiderBacktesterCriteria,
  defaultInsiderBacktesterClusterCriteria
} from '@/data/constants'

import {
  defaultWhaleTraderCriteria,
  buy_signal_frequencies,
  risk_unit_types,
  existing_position_buy_actions,
  fully_invested_actions,
  volatility_time_periods,
  atr_time_periods,
  exit_time_periods,
  volume_time_periods,
  volatility_sizing,
  overcrowding_sizing_options
} from '@/data/whale_trader_constants'

export const useAppStore = defineStore('app', {
  state: () => ({
    drawer: true,
    loginDialog: false,
    notification: {
      value: false,
      type: 'error',
      text: 'Server returned an error. Please try again later.'
    },
    selectedGroup: cloneDeep(defaultSelectedGroup),
    alertCriteria: cloneDeep(defaultAlertCriteria),
    backtesterCriteria: cloneDeep(defaultBacktesterCriteria),
    insiderBacktesterCriteria: cloneDeep(defaultInsiderBacktesterCriteria),
    insiderBacktesterClusterCriteria: cloneDeep(defaultInsiderBacktesterClusterCriteria),
    etfFilter: 0,
    adrFilter: 0,
    whaleTraderCriteria: cloneDeep(defaultWhaleTraderCriteria),
    signalView: null,
    buy_signal_frequencies,
    risk_unit_types,
    existing_position_buy_actions,
    fully_invested_actions,
    volatility_time_periods,
    atr_time_periods,
    exit_time_periods,
    volume_time_periods,
    volatility_sizing,
    overcrowding_sizing_options,
    current_trading_model: null,
    current_screen: null,
    trendFinderCriteria: {
      include_sp500: false,
      include_recession: false,
      start_date: '2001-01-01',
      end_date: new Date().toISOString().substr(0, 10),
      interval: 'yearly',
      measures: [],
      current_measure: {
        measure: -1,
        label: '',
        aggregation: 'sum',
        filters: [],
        chart_type: 0,
        filter_choice: 0,
        filer_group: { id: -1, filers: [] }
      }
    },
    form_d_measure: { filters: [] },
    form_13f_measure: { filters: [] },
    form_13d_measure: { filters: [] },
    form_4_measure: { filters: [] }
  }),

  actions: {
    setDrawer(payload) {
      this.drawer = payload
    },

    toggleDrawer() {
      this.drawer = !this.drawer
    },

    showNotification({ type, text }) {
      this.notification.value = true
      if (type) this.notification.type = type
      if (text) this.notification.text = text
    },

    setSelectedGroup(group) {
      this.selectedGroup = group || {
        id: null,
        description: 'New Group',
        visibility_type_id: 0,
        filers: []
      }
    }
  }
})
